import { AdminBadgesScreen } from '@/screens/admin/admin-badges-screen'

export default function () {
  return <AdminBadgesScreen />
}